"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionMoveModalCtrl = void 0;
var tslib_1 = require("tslib");
var core_api_1 = require("@ikegps/core-api");
var mobx_1 = require("mobx");
var services_1 = require("../../services");
var store_1 = require("../../store");
var CollectionMoveModalCtrl = /** @class */ (function () {
    function CollectionMoveModalCtrl(collections) {
        this.moving = false;
        this.collections = collections;
    }
    CollectionMoveModalCtrl.prototype.moveCollections = function (departmentId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var collectionsByTag, _i, _a, collection, tagId, _b, _c, tagId, collectionGroup, tag;
            return tslib_1.__generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        if (departmentId == null || this.moving) {
                            return [2 /*return*/];
                        }
                        collectionsByTag = {};
                        for (_i = 0, _a = this.collections; _i < _a.length; _i++) {
                            collection = _a[_i];
                            tagId = collection.tags.find(function (t) { return !(0, core_api_1.isSystemTag)(t); });
                            if (collectionsByTag[tagId] != null) {
                                collectionsByTag[tagId].push(collection);
                            }
                            else {
                                collectionsByTag[tagId] = [collection];
                            }
                        }
                        this.setMoving(true);
                        _b = 0, _c = Object.keys(collectionsByTag);
                        _d.label = 1;
                    case 1:
                        if (!(_b < _c.length)) return [3 /*break*/, 4];
                        tagId = _c[_b];
                        collectionGroup = collectionsByTag[tagId];
                        tag = store_1.AppStore.Tag.get(tagId);
                        return [4 /*yield*/, services_1.Services.Collection.move(collectionGroup, tag.name, departmentId)];
                    case 2:
                        _d.sent();
                        _d.label = 3;
                    case 3:
                        _b++;
                        return [3 /*break*/, 1];
                    case 4:
                        this.setMoving(false);
                        return [2 /*return*/];
                }
            });
        });
    };
    CollectionMoveModalCtrl.prototype.setMoving = function (moving) {
        this.moving = moving;
    };
    tslib_1.__decorate([
        mobx_1.observable
    ], CollectionMoveModalCtrl.prototype, "tagName", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], CollectionMoveModalCtrl.prototype, "moving", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], CollectionMoveModalCtrl.prototype, "setMoving", null);
    return CollectionMoveModalCtrl;
}());
exports.CollectionMoveModalCtrl = CollectionMoveModalCtrl;
//# sourceMappingURL=collection.move.modal.ctrl.js.map